<template>
  <div>
    <div class="dx-fieldset">
      <div class="dx-field">
        <div class="dx-field-label">Enter Password To Update</div>
        <div class="dx-field-value">
          <DxTextBox
            :input-attr="{ 'aria-label': 'Password' }"
            :value="passwordBox"
            @value-changed="onValueChanged"
          >
          </DxTextBox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { DxSelectBox } from "devextreme-vue/select-box";
import CustomStore from "devextreme/data/custom_store";
import {
  DxTextBox,
  DxButton as DxTextBoxButton,
} from "devextreme-vue/text-box";
const passwordMode = ref("password");

const passwordButton = ref({
  icon: "eyeopen",
  stylingMode: "text",
  onClick: () => {
    passwordMode.value = passwordMode.value === "text" ? "password" : "text";
  },
});

let relateRoute;

function setRelatedRoute(context) {
  relateRoute = context.rRoute;
}

export default {
  props: {
    rRoute: String,
    slug: String,
    modelValue: String,
  },
  components: {
    DxSelectBox,
    CustomStore,
    DxTextBox,
    DxTextBoxButton,
  },
  data() {
    return {
      gridDataSource: null,
      passwordBox: "",
      searchModeOption: "contains",
      searchExprOption: "name",
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      showDataBeforeSearchOption: true,
    };
  },
  created() {
    //this.gridDataSource = this.makeAsyncDataSource("customers.json");

    relateRoute = this.rRoute;
  },
  methods: {
    onValueChanged(e) {
      console.log("selected requestPasword  onValueChanged", e.value);

      this.passwordBox = e.value;
      this.$emit("update:modelValue", e.value);
    },
  },
  mounted() {
    this.passwordBox = this.modelValue;
  },
};
</script>

<style>
.instruction {
  margin: 70px 15px 0px 15px;
}
ul {
  list-style-type: square;
  padding: 0;
  /* margin: 70px 15px 0px 15px; */
}

li {
  margin-bottom: 3px;
  color: grey;
  /* background-color: #f0f0f0;
      padding: 2px;
      border-radius: 4px; */
}
</style>